declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

type GtmEvent =
  | { name: "click_plan_button"; params: { plan_name: string } }
  | { name: "view_example_category"; params: { category: string } }
  | { name: "click_whatsapp"; params: { type: string } }
  | { name: "click_nav_link"; params: { link: string } };

export function trackEvent(event: GtmEvent): void {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: event.name, ...event.params });
}
